define(function (require) {
    "use strict";

    var LE = require("app");

    var template = require("manager-templates/special-occasion/specialOccasionShiftTimePickView.tmpl");

    var SingleSelect = require("ui/singleselect-new/Singleselect");
    var ScheduleUtilities = require("utils/ScheduleUtilities");

    var SpecialOccasionShiftTimePickView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionShiftTimePickView = Marionette.ItemView.extend({
            template: template,
            ui: {
                resultsWrapper: ".results-wrapper",
                startTimeSingleSelectContainer: ".single-select-wrapper .start-time",
                endTimeSingleSelectContainer: ".single-select-wrapper .end-time",
                singleSelectsWrapper: ".single-select-wrapper",
                startTimeResult: ".results-wrapper .start-time",
                endTimeResult: ".results-wrapper .end-time"
            },
            withUIComponents: true,
            events: {
                "clickoutside": "_handleOutsideClick",
                "click @ui.resultsWrapper": "_resultsWrapperClicked"
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            setErrors: function(errors) {
                this._setErrors(errors);
            },

            hideErrors: function() {
                this._hideErrors();
            },

            _initialize: function(options) {
                this.channel = options.channel;
            },

            _onRender: function() {
                var startTimeValue = this._getStartTimeSelectedItem();
                var endTimeValue = this._getEndTimeSelectedItem();
                var shiftTimeOptionsAsMap = ScheduleUtilities.getShiftTimesOptionsForSingleSelectAsMap();
                if (!shiftTimeOptionsAsMap[startTimeValue] || !shiftTimeOptionsAsMap[endTimeValue]) {
                    this.ui.resultsWrapper.toggleClass("hide", true);
                    this.ui.singleSelectsWrapper.toggleClass("hide", false);
                    this._renderShiftTimes();
                }
                else {
                    this.ui.resultsWrapper.toggleClass("hide", false);
                    this.ui.singleSelectsWrapper.toggleClass("hide", true);
                    this.ui.startTimeResult.text(shiftTimeOptionsAsMap[startTimeValue].value);
                    this.ui.endTimeResult.text(shiftTimeOptionsAsMap[endTimeValue].value);
                }
            },

            _renderShiftTimes: function() {
                this._renderShiftStartTime();
                this._renderShiftEndTime();
            },

            _renderShiftStartTime: function() {
                this.uiComponents.host$.createAndRender("startTime", {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.startTimeSingleSelectContainer",
                        permutation: SingleSelect.PERMUTATION.P,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        useCreateNewItemOption: false,
                        list: {
                            itemHeight: 30,
                            itemsComparator: "id",
                            maxShownItems: 7,
                            pageSize: 10
                        },
                        inputField: {
                            placeholder: LE.translator.translate("LEManager.specialOccasionEditView.eventsTable.shifts.from")
                        },
                        items: "view._getTimesSingleSelectOptions",
                        selectedItem: "view._getStartTimeSelectedItem"
                    },
                    events: {
                        "change": "_onStartTimeChange",
                        "input:change": "_onStartTimeChange",
                        "blur": "_validateTimeInput"
                    }
                });
            },

            _renderShiftEndTime: function() {
                this.uiComponents.host$.createAndRender("endTime", {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.endTimeSingleSelectContainer",
                        permutation: SingleSelect.PERMUTATION.P,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        useCreateNewItemOption: false,
                        list: {
                            itemHeight: 30,
                            itemsComparator: "id",
                            maxShownItems: 7,
                            pageSize: 10
                        },
                        inputField: {
                            placeholder: LE.translator.translate("LEManager.specialOccasionEditView.eventsTable.shifts.to")
                        },
                        items: "view._getTimesSingleSelectOptions",
                        selectedItem: "view._getEndTimeSelectedItem"
                    },
                    events: {
                        "change": "_onEndTimeChange",
                        "input:change": "_onEndTimeChange",
                        "blur": "_validateTimeInput"
                    }
                });
            },

            _getStartTimeSelectedItem: function () {
                return this.model.getStartTime();
            },

            _getEndTimeSelectedItem: function () {
                return this.model.getEndTime();
            },

            _getTimesSingleSelectOptions: function() {
                return ScheduleUtilities.getShiftTimesOptionsForSingleSelect();
            },

            _onStartTimeChange: function(componentId, eventName, value) {
                var id = _.has(value, "item") ? value.item.id : "";
                var timeObj = this.uiComponents.startTime.getSelectedItem();

                if (!_.isEmpty(timeObj)) {
                    id = timeObj.id;
                }

                this.channel.trigger("SpecialOccasionShiftTimePickView:change:hours:startTime", this.model, id);
            },

            _onEndTimeChange: function(componentId, eventName, value) {
                var id = _.has(value, "item") ? value.item.id : "";
                var timeObj = this.uiComponents.endTime.getSelectedItem();

                if (!_.isEmpty(timeObj)) {
                    id = timeObj.id;
                }

                this.channel.trigger("SpecialOccasionShiftTimePickView:change:hours:endTime", this.model, id);
            },

            _validateTimeInput : function (componentId, eventName) {
                var timeVal = this.uiComponents[componentId].getInputValue();
                var timeObj = this.uiComponents[componentId].getSelectedItem();
                if (!_.isEmpty(timeVal)) {  // only if not empty value
                    if (_.isEmpty(timeObj)) {
                        this.uiComponents[componentId].setError(true, LE.translator.translate("LEManager.specialOccasionEditView.eventsTable.shifts.error.unknownTime"));
                        return false;
                    } else {
                        this.uiComponents[componentId].setInputValue(timeObj.value);
                    }
                }

                return true;
            },

            _setErrors: function(errors) {
                this._hideErrors();

                if (_.has(errors, this.model.KEYS.START_TIME)){
                    this.uiComponents.startTime.setError(true, errors.startTime);
                }
                if (_.has(errors, this.model.KEYS.END_TIME)){
                    this.uiComponents.endTime.setError(true, errors.endTime);
                }
            },

            _hideErrors: function() {
                this.uiComponents.startTime.setError(false);
                this.uiComponents.endTime.setError(false);
            },

            _handleOutsideClick: function() {
                if (_.has(this.uiComponents, "startTime") && _.has(this.uiComponents, "endTime")) {
                    var startTimeInputValue = this.uiComponents.startTime.getInputValue();
                    var endTimeInputValue = this.uiComponents.endTime.getInputValue();
                    if (this._validateTimeInput("startTime") && !_.isEmpty(startTimeInputValue) && this._validateTimeInput("endTime") && !_.isEmpty(endTimeInputValue) && this.model.isValidAttr()) {
                        this._closeShiftStartTime();
                        this._closeShiftEndTime();

                        this.ui.singleSelectsWrapper.toggleClass("hide", true);
                        this.ui.resultsWrapper.toggleClass("hide", false);

                        this.ui.startTimeResult.text(startTimeInputValue);
                        this.ui.endTimeResult.text(endTimeInputValue);
                    }
                }
            },

            _resultsWrapperClicked: function() {
                this._renderShiftTimes();
                this.ui.singleSelectsWrapper.toggleClass("hide", false);
                this.ui.resultsWrapper.toggleClass("hide", true);
                this.ui.startTimeResult.text("");
                this.ui.endTimeResult.text("");
            },

            _closeShiftStartTime: function() {
                if (this.uiComponents && this.uiComponents.startTime) {
                    this.uiComponents.startTime.close();
                }
            },

            _closeShiftEndTime: function() {
                if (this.uiComponents && this.uiComponents.endTime) {
                    this.uiComponents.endTime.close();
                }
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionShiftTimePickView;

});
